import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spacer-block',
  templateUrl: './spacer-block.component.html',
})
export class SpacerBlockComponent {
  @Input() height = 10;
}
